"use client";

import { useSurvey } from "./survey-provider";
import { formatNumber } from "@/lib/utils";

interface BlurredEntitiesOverlayProps {
  hiddenCount: number;
}

export function BlurredEntitiesOverlay({ hiddenCount }: BlurredEntitiesOverlayProps) {
  const { openSurvey } = useSurvey();

  return (
    <div className="relative mt-3">
      <div className="flex flex-col gap-3 opacity-50 blur-[2px]">
        {Array.from({ length: 2 }).map((_, idx) => (
          <div key={idx} className="flex items-center gap-3 rounded-lg border border-zinc-200 bg-white p-4">
            <div className="h-8 w-8 rounded-md bg-zinc-100" />
            <div className="flex-1 space-y-2">
              <div className="h-4 w-48 rounded bg-zinc-100" />
              <div className="h-3 w-32 rounded bg-zinc-100" />
            </div>
          </div>
        ))}
      </div>
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-2">
        {hiddenCount > 0 && (
          <p className="text-sm font-medium text-zinc-900">
            +{formatNumber(hiddenCount)} more entities not shown
          </p>
        )}
        <button
          type="button"
          onClick={openSurvey}
          className="inline-flex items-center gap-1.5 rounded bg-zinc-900 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-zinc-800"
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
          See all entities
        </button>
      </div>
    </div>
  );
}
